import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material'
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function Associados() {
  const [pessoas, setPessoas] = useState([]);
  const [totalPessoas, setTotalPessoas] = useState(0);
  const [modalInfo, setModalInfo] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectStatus, setSelectStatus] = useState('');
  const [isLoadingMOD, setIsLoadingMOD] = useState(false);
  
  const [menuAberto, setMenuAberto] = useState(false);
  const associado = parseInt(sessionStorage.getItem('pesAssociado'));
  const navigate = useNavigate();
  const location = useLocation();
  const loggedIn = sessionStorage.getItem('loggedIn');
  
  useEffect(() => {
      if (loggedIn === false || loggedIn === null || loggedIn === undefined) {
          navigate('/Login');
          window.location.reload();
      }
      }, []);

  const now = new Date();
  const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
  year: 'numeric',
  day: '2-digit',
  month: '2-digit',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false
  }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

  //ordenação do resultado pessoas
  
  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);

    const sortedItems = useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = key => {
      let direction = 'ascending';
      if (sortConfig && 
        sortConfig.key === key && 
        sortConfig.direction === 'ascending'
      ) {
        direction = 'descending';
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };
  const { items, requestSort, sortConfig } = useSortableData(pessoas);

  const getClassNamesFor = name => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined
  }

  useEffect(() => {
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    setIsLoadingMOD(true);
    
      axios
        .get(
          process.env.REACT_APP_API_URL +
          '/routes.php?metodo=exibirTodasPessoas',
          { headers: { 
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=UTF-8"
          } }
        )
        .then(response => {
          //console.log(response.data)
          setPessoas(response.data)
          setTotalPessoas(response.data.length);
          setIsLoadingMOD(false);
        })
        .catch(error => {
          let ret = error.message;
          setIsLoadingMOD(false);
          if (ret.includes("401")) {
            console.log("token inválido!")
          }
          else if (ret.includes("403")) {
            //window.location.reload();
          }
        })
  }, [])
  
  //functions
  function carregarPessoas() {
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    setIsLoadingMOD(true);
    
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=exibirTodasPessoas',
        { headers: { 
          "X-Access-Token": token,
          "Content-Type": "application/json; charset=UTF-8"
        } }
      )
      .then(response => {
        //console.log(response.data)
        setPessoas(response.data)
        setTotalPessoas(response.data.length);
        setIsLoadingMOD(false);
      })
      .catch(error => {
        let ret = error.message;
        setIsLoadingMOD(false);
        if (ret.includes("401")) {
          console.log("token inválido!")
        }
        else if (ret.includes("403")) {
          //window.location.reload();
        }
      })
  }
  function handlePesquisaStatusChange(event) {
    sessionStorage.selectStatusRegistroAssociado = event.target.value
    setSelectStatus(sessionStorage.selectStatusRegistroAssociado)
    contarPessoas();
  }
  function handleNovoCadastro(){
    setModalOpen(false);
  }

  //vai para linha de foco após edição
  useEffect(() => {
    
    const itemClicadoId = sessionStorage.getItem('itemClicadoId');

    if (itemClicadoId) {
      const elementoLinha = document.getElementById(`linha-${itemClicadoId}`);
      
      if (elementoLinha) {
        // Rola até a linha clicada de forma suave
        setTimeout(() => {
          elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Destaque visual temporário opcional (ex: piscar a linha)
          elementoLinha.style.backgroundColor = '#fff9c4'; 
          setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
        }, 100); // Um pequeno delay garante que o HTML já renderizou

        // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
        sessionStorage.removeItem('itemClicadoId');
      }
    }
  }, [pessoas]);

  function handleEditPessoa(pessoa){
    // setModalInfo(pessoa);
    // setModalOpen(true);
    //console.log(pessoa);
    sessionStorage.setItem('itemClicadoId', pessoa.IdPessoa);
    sessionStorage.setItem('origemEditarPessoa', 'Associado');
    navigate(`/Cadastro`, { state: { cadastro: pessoa } });
    //window.location.reload();
  }

  function handleSelectPosicaoChange(pessoa){
    //exibir uma janela de confirmação antes de alterar o valor do checkbox
    if (window.confirm(`Tem certeza que deseja ${parseInt(pessoa.pesAssociado) === 1 ? 'desassociar' : 'associar'} ${pessoa.pesNome} ?`)) {
      sessionStorage.setItem('itemClicadoId', pessoa.IdPessoa);
      gravarAlteracaoAssociado(pessoa);
    } 
    // else {
    //   event.preventDefault();
    //   event.target.checked = !event.target.checked;
    // }
  }
  function gravarAlteracaoAssociado(pessoa) {
    setIsLoadingMOD(true);
    var novoValor = parseInt(pessoa.pesAssociado) === 1 ? 0 : 1;

    //var authTKN = authService.validateToken();
    //var token = sessionStorage.token.replace('"', '').replace('"', '');// authService.getCurrentToken("token");
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    const dados = {
      IdPessoa: pessoa.IdPessoa,
      pesAssociado: novoValor,
      pesAlteradoPor: sessionStorage.nomeUsuario,
      pesAlteradoEm: customFormatDate
    };

    axios
      .post(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=atualizarAssociadoPessoa',
        dados,
        { headers: { 
          "X-Access-Token": token,
          "Content-Type": "application/json; charset=UTF-8"
        } }
      )
      .then(response => {
        //console.log(response.data)
        //atualizar lista
        setPessoas(prevPessoas => 
          prevPessoas.map(p => 
            p.IdPessoa === pessoa.IdPessoa 
              ? { ...p, pesAssociado: novoValor } 
              : p
          )
        );
        //contarPessoas();
        //carregarPessoas();
        //window.location.reload();
      })
      .catch(error => {
        let ret = error.message;
        if (ret.includes("401")) {
          console.log("token inválido!")
        }
        else if (ret.includes("403")) {
          //window.location.reload();
        }
      })
      .finally(() => {
        setIsLoadingMOD(false);
      });
  }

  function handleSelectStatusChange(pessoa){
    if (window.confirm(`Tem certeza que deseja ${parseInt(pessoa.pesStatus) === 1 ? 'inativar' : 'ativar'} o cadastro de ${pessoa.pesNome} ?`)) {
      sessionStorage.setItem('itemClicadoId', pessoa.IdPessoa);
      gravarAlteracaoStatus(pessoa);
    }
  }
  function gravarAlteracaoStatus(pessoa) {
    setIsLoadingMOD(true);
    var novoValor = parseInt(pessoa.pesStatus) === 1 ? 0 : 1;

    //var authTKN = authService.validateToken();
    //var token = sessionStorage.token.replace('"', '').replace('"', '');// authService.getCurrentToken("token");
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    const dados = {
      IdPessoa: pessoa.IdPessoa,
      pesStatus: novoValor,
      pesAlteradoPor: sessionStorage.nomeUsuario,
      pesAlteradoEm: customFormatDate
    };

    axios
      .post(
        process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarStatusPessoa',
        dados,
        { headers: { 
          "X-Access-Token": token,
          "Content-Type": "application/json; charset=UTF-8"
        } }
      )
      .then(response => {
        //console.log(response.data)
        //atualizar lista
        setPessoas(prevPessoas => 
          prevPessoas.map(p => 
            p.IdPessoa === pessoa.IdPessoa 
              ? { ...p, pesStatus: novoValor } 
              : p
          )
        );
        //contarPessoas();
      })
      .catch(error => {
        let ret = error.message;
        if (ret.includes("401")) {
          console.log("token inválido!")
        }
        else if (ret.includes("403")) {
          //window.location.reload();
        }
      })
      .finally(() => {
        setIsLoadingMOD(false);
      });
  }

  function handleSelectAdminChange(pessoa){
    if (window.confirm(`Tem certeza que deseja ${parseInt(pessoa.pesAdmin) === 1 ? 'remover' : 'conceder'} privilégios de administrador para ${pessoa.pesNome} ?`)) {
      sessionStorage.setItem('itemClicadoId', pessoa.IdPessoa);
      gravarAlteracaoAdmin(pessoa);
    }
  }
  function gravarAlteracaoAdmin(pessoa) {
    setIsLoadingMOD(true);
    var novoValor = parseInt(pessoa.pesAdmin) === 1 ? 0 : 1;

    //var authTKN = authService.validateToken();
    //var token = sessionStorage.token.replace('"', '').replace('"', '');// authService.getCurrentToken("token");
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    const dados = {
      IdPessoa: pessoa.IdPessoa,
      pesAdmin: novoValor,
      pesAlteradoPor: sessionStorage.nomeUsuario,
      pesAlteradoEm: customFormatDate
    };

    axios
      .post(
        process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarAdminPessoa',
        dados,
        { headers: { 
          "X-Access-Token": token,
          "Content-Type": "application/json; charset=UTF-8"
        } }
      )
      .then(response => {
        //console.log(response.data)
        //atualizar lista
        setPessoas(prevPessoas => 
          prevPessoas.map(p => 
            p.IdPessoa === pessoa.IdPessoa 
              ? { ...p, pesAdmin: novoValor } 
              : p
          )
        );
        //contarPessoas();
      })
      .catch(error => {
        let ret = error.message;
        if (ret.includes("401")) {
          console.log("token inválido!")
        }
        else if (ret.includes("403")) {
          //window.location.reload();
        }
      })
      .finally(() => {
        setIsLoadingMOD(false);
      });
  }

  // function contarPessoas() {
  //   let pessoasAtivas = 0;
  //   if (parseInt(sessionStorage.selectStatusRegistroAssociado) !== 99) {
  //     pessoasAtivas = pessoas.filter(p => parseInt(p.pesStatus) === parseInt(sessionStorage.selectStatusRegistroAssociado));
  //   }
  //   else {
  //     pessoasAtivas = pessoas.filter(p => true);
  //   }
  //   setTotalPessoas(pessoasAtivas.length);
  // };

  function contarPessoas() {
    let pessoasFiltro = 0;
    if (searchTerm === '') {
      console.log("searchTerm is empty");
      if (parseInt(sessionStorage.selectStatusRegistroAssociado) 
          !== 99) {
        pessoasFiltro = pessoas.filter(p => parseInt(p.pesStatus) 
          === parseInt(sessionStorage.selectStatusRegistroAssociado));
      }
      else {
        pessoasFiltro = pessoas.filter(p => true);
      }
    } else if (searchTerm !== '' 
      && parseInt(sessionStorage.selectStatusRegistroAssociado) 
      !== 99) {
        console.log("searchTerm is not empty and status filter is applied");
        pessoasFiltro = pessoas.filter(val => parseInt(val.pesStatus) 
          === parseInt(sessionStorage.selectStatusRegistroAssociado) 
        && 
        (
          val.pesNome
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) 
            ||
          val.pesApelido
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) 
            ||
          val.pesProfissao
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) 
            ||
          val.pesEmail
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
            ||
          val.pesCidade  !== null && val.pesCidade
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
            ||
          val.pesEstado  !== null && val.pesEstado
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      );
    }
    else {
      console.log("searchTerm is not empty and no status filter is applied");
      pessoasFiltro = pessoas.filter(val => 
        val.pesNome
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) 
          ||
        val.pesApelido
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) 
          ||
        val.pesProfissao
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) 
          ||
        val.pesEmail
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
          ||
        val.pesCidade !== null && val.pesCidade
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
          ||
        val.pesEstado !== null && val.pesEstado
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    }
    setTotalPessoas(pessoasFiltro.length);
  };

  function pesquisar(term) {
    setSearchTerm(term);
    contarPessoas();
  }

  const toggleMenu = () => {
      setMenuAberto(!menuAberto);
  };

  const toggleLogoff = () => {
  localStorage.clear();
  localStorage.setItem('loggedIn', false);
  localStorage.removeItem('user');
  sessionStorage.clear();
  
  navigate('/');
  window.location.reload();
  }

  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Associados",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  //identificar a resolução da tela para ajustar o tamanho da tabela
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <main style={{paddingBottom: '80px'}}>
        <div>
          <div>
            <MenuAssociados />
          </div>
          {/* exibir em uma div a resolução da tela */}
          {/* <div>Resolução da tela: {windowWidth}px</div> */}
          <div className='headerMain'>
            <label className='labelTitulo' >ASSOCIADOS</label>
            <label className='labelSubTitulo'>Lista dos Associados</label>
          </div>

          {/* <div>
            {modalOpen && (<Cadastro setOpenModal={setModalOpen} cadastroInfo={modalInfo} />)}
          </div> */}

          <div className="containerBarraPesquisa">

          {parseInt(sessionStorage.pesAdmin) === 1 ? (
            <Link to="/Cadastro">
              <button className="buttonModalPadrao" onClick={handleNovoCadastro}>
              NOVO REGISTRO
            </button>
            </Link> ) : ('')}


            <input className="inputBarraPesquisa"
              placeholder="PESQUISAR"
              type="text"
              id="inputPesquisa"
              name="inputPesquisa"
              onChange={event => {
                pesquisar(event.target.value);
                // setSearchTerm(event.target.value)
                // contarPessoas()
              }}
            />

            <select className="selectStatusPesquisa"
              name="selectStatusRegistroAssociado"
              selected={sessionStorage.selectStatusRegistroAssociado !== undefined ? sessionStorage.selectStatusRegistroAssociado : '99'}
              onChange={event => {
                handlePesquisaStatusChange(event)
              }}
            >
              <option value={'99'} selected={sessionStorage.selectStatusRegistroAssociado === '99'} >TODOS</option>
              <option value={'1'} selected={sessionStorage.selectStatusRegistroAssociado === '1'} >ATIVOS</option>
              <option value={'0'} selected={sessionStorage.selectStatusRegistroAssociado === '0'} >INATIVOS</option>
            </select>

            <div>Total de Registros: {totalPessoas}</div>

          </div>

        </div>
              
        {/* <ContainerPage> */}
          <div className="tabelaPadrao">
            {windowWidth < 769 ? 
              // <div className="tabelaPadrao">
              isLoadingMOD ? 
                  <tr><td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :  
              
                  items
                  .filter(val => {
                    if (searchTerm === '') {
                      //return val
                      if(sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado === '99')
                        {
                          return val
                        }
                        else if (sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado !== '99')
                        {
                          if(parseInt(sessionStorage.selectStatusRegistroAssociado) === parseInt(val.pesStatus))
                          {
                            return val
                          }
                        }
                        else{
                          return val
                        }
                    } else if (
                      val.pesNome
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) 
                        ||
                      val.pesApelido
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) 
                        ||
                      val.pesProfissao
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) 
                        ||
                      val.pesEmail
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                        ||
                      val.pesCidade  !== null && val.pesCidade
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                        ||
                      val.pesEstado  !== null && val.pesEstado
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    ) {
                      //return val
                      if(sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado === '99')
                        {
                          return val
                        }
                        else if (sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado !== '99')
                        {
                          if(parseInt(sessionStorage.selectStatusRegistroAssociado) === parseInt(val.pesStatus))
                          {
                            return val
                          }
                        }
                        else{
                          return val
                        }
                    }
                  })  
                  .map(pessoa => (
                    <div key={pessoa.IdPessoa} id={`linha-${pessoa.IdPessoa}`} style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                      <div 
                        key={pessoa.IdPessoa} 
                        onClick={() => handleEditPessoa(pessoa)}
                        className="p2" style={{ cursor: 'pointer' }}
                        > 
                        <div className='tdAlignLeft'>
                          <p><span style={{ color: '#000' }}><b>CÓD:</b> MGBE{pessoa.IdPessoa < 10 ? `000${pessoa.IdPessoa}` : pessoa.IdPessoa < 100 ? `00${pessoa.IdPessoa}` : pessoa.IdPessoa < 1000 ? `0${pessoa.IdPessoa}` : pessoa.IdPessoa}</span></p>
                          <p style={{ color: '#000', marginTop: '10px' }}><b> Nome:</b> {pessoa.pesNome}</p>
                          
                        </div>
                        <div style={{ color: '#000' }}>
                          <p style={{ color: '#000', marginTop: '10px' }}><strong>Apelido:</strong> {pessoa.pesApelido}</p>
                          <p style={{ color: '#000', marginTop: '10px' }}><strong>Profissão:</strong> {pessoa.pesProfissao}</p>
                          <p style={{ color: '#000', marginTop: '10px' }}><strong>Cidade:</strong> {pessoa.pesCidade}<strong> Estado:</strong> {pessoa.pesEstado}</p>
                          <p style={{ color: '#000', marginTop: '10px' }}><strong>Cadastro:</strong> {pessoa.pesCriadoEM.substring(0,10)}</p>
                        </div>
                      </div>
                      <div className="p2">
                        <div>
                          {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <>
                              <div id={`linha-${pessoa.IdPessoa}`}>
                                <label style={{ color: parseInt(pessoa.pesAssociado) === 1 ? 'green' : 'red', cursor: 'pointer' }}>
                                    <label style={{ cursor: 'pointer', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSelectPosicaoChange(pessoa)}>
                                      {parseInt(pessoa.pesAssociado) === 1 
                                      ? 
                                      <ThumbUpAlt style={{ color: 'green', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} /> 
                                      : 
                                      <ThumbUpAlt style={{ color: 'red', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} />}
                                      {parseInt(pessoa.pesAssociado) === 1 ? ' ASSOCIADO - Alterar para não associado' : ' NÃO ASSOCIADO - Alterar para associado'}
                                    </label>
                                </label>
                              </div>
                              <div style={{ marginTop: '10px' }}>
                                <label style={{ color: parseInt(pessoa.pesStatus) === 1 ? 'green' : 'red', cursor: 'pointer' }}>
                                    <label style={{ cursor: 'pointer', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSelectStatusChange(pessoa)}>
                                    {parseInt(pessoa.pesStatus) === 1 
                                    ? 
                                    <ThumbUpAlt style={{ color: 'green', marginRight: '5px', cursor: 'pointer' }} /> 
                                    : 
                                    <ThumbUpAlt style={{ color: 'red', marginRight: '5px', cursor: 'pointer' }} />}
                                    {parseInt(pessoa.pesStatus) === 1 ? ' ATIVO - Alterar para inativo' : ' INATIVO - Alterar para ativo'}
                                  </label>
                                </label>
                              </div>
                              <div style={{ marginTop: '10px' }}>
                                <label style={{ color: parseInt(pessoa.pesAdmin) === 1 ? 'green' : 'red', cursor: 'pointer' }}>
                                    <label style={{ cursor: 'pointer', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSelectAdminChange(pessoa)}>
                                    {parseInt(pessoa.pesAdmin) === 1 
                                    ? 
                                    <ThumbUpAlt style={{ color: 'green', marginRight: '5px', cursor: 'pointer' }} /> 
                                    : 
                                    <ThumbUpAlt style={{ color: 'red', marginRight: '5px', cursor: 'pointer' }} />}
                                    {parseInt(pessoa.pesAdmin) === 1 ? ' ADMIN - Alterar para não admin' : ' NÃO ADMIN - Alterar para admin'}
                                  </label>
                                </label>
                              </div>
                              {/* <p style={{ color: '#000', marginTop: '10px' }}><strong>Associado:</strong> {parseInt(pessoa.pesAssociado) === 1 ? 'Sim' : 'Não'}</p>
                              <p style={{ color: '#000', marginTop: '10px' }}><strong>Cadastro:</strong> {parseInt(pessoa.pesStatus) === 1 ? 'Ativo' : 'Inativo'}</p>
                              <p style={{ color: '#000', marginTop: '10px' }}><strong>Gestão:</strong> {parseInt(pessoa.pesAdmin) === 1 ? 'Sim' : 'Não'}</p> */}
                            </>
                          ) : ''}
                        </div>
                      </div>
                    </div>
                  )) : 
                  (
                  <table>
                      <thead>
                        <tr className='tdAlignLeft'>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('IdPessoa')}
                          className={getClassNamesFor('IdPessoa')}
                          >
                            CÓD
                          </th>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesNome')}
                          className={getClassNamesFor('pesNome')}
                          >
                            NOME
                          </th>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesApelido')} 
                          className={getClassNamesFor('pesApelido')}>
                            APELIDO
                          </th>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesProfissao')} 
                          className={getClassNamesFor('pesProfissao')}>
                            PROFISSÃO
                          </th>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesCidade')} 
                          className={getClassNamesFor('pesCidade')}>
                            CIDADE
                          </th>
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesEstado')} 
                          className={getClassNamesFor('pesEstado')}>
                            ESTADO
                          </th>
                          {parseInt(sessionStorage.pesAdmin) === 1 ? (
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesAssociado')} 
                          className={getClassNamesFor('pesAssociado')}>
                            ASSOCIADO
                          </th>
                          ) : ''}
                          {parseInt(sessionStorage.pesAdmin) === 1 ? (
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesStatus')} 
                          className={getClassNamesFor('pesStatus')}>
                            STATUS
                          </th>
                          ) : ''}
                          {parseInt(sessionStorage.pesAdmin) === 1 ? (
                          <th style={{ cursor: 'pointer' }}
                          onClick={() => requestSort('pesAdmin')} 
                          className={getClassNamesFor('pesAdmin')}>
                            ADMIN
                          </th> 
                          ) : ''}
                        </tr>
                      </thead>
                      <tbody>
                        {
                        isLoadingMOD ? <tr><td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                        items
                        .filter(val => {
                          if (searchTerm === '') {
                            //return val
                            if(sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado === '99')
                              {
                                return val
                              }
                              else if (sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado !== '99')
                              {
                                if(parseInt(sessionStorage.selectStatusRegistroAssociado) === parseInt(val.pesStatus))
                                {
                                  return val
                                }
                              }
                              else{
                                return val
                              }
                          } else if (
                            val.pesNome
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) 
                              ||
                            val.pesApelido
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) 
                              ||
                            val.pesProfissao
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) 
                              ||
                            val.pesEmail
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                              ||
                            val.pesCidade  !== null && val.pesCidade
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                              ||
                            val.pesEstado  !== null && val.pesEstado
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                          ) {
                            //return val
                            if(sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado === '99')
                              {
                                return val
                              }
                              else if (sessionStorage.selectStatusRegistroAssociado !== undefined && sessionStorage.selectStatusRegistroAssociado !== '99')
                              {
                                if(parseInt(sessionStorage.selectStatusRegistroAssociado) === parseInt(val.pesStatus))
                                {
                                  return val
                                }
                              }
                              else{
                                return val
                              }
                          }
                        })
                        .map(pessoa => (
                            <tr key={pessoa.IdPessoa} id={`linha-${pessoa.IdPessoa}`} style={{ cursor: 'pointer' }}>
                              <td className='tdAlignCenter'>
                                MGBE{pessoa.IdPessoa < 10 ? `000${pessoa.IdPessoa}` : pessoa.IdPessoa < 100 ? `00${pessoa.IdPessoa}` : pessoa.IdPessoa < 1000 ? `0${pessoa.IdPessoa}` : pessoa.IdPessoa}
                              </td>

                              <td style={{
                                textTransform: 'uppercase'
                              }} onClick={() => handleEditPessoa(pessoa)}>
                                {pessoa.pesNome} <br /> 
                                <span style={{ textTransform: 'lowercase', fontSize: '12px' }}>{pessoa.pesEmail}</span>
                              </td>

                              <td style={{
                                textTransform: 'uppercase'
                              }} onClick={() => handleEditPessoa(pessoa)}>
                                {pessoa.pesApelido}
                              </td>

                              <td style={{
                                textTransform: 'uppercase'
                              }} onClick={() => handleEditPessoa(pessoa)}>
                                {pessoa.pesProfissao}
                              </td>

                              <td style={{
                                textTransform: 'uppercase'
                              }} onClick={() => handleEditPessoa(pessoa)}>
                                {pessoa.pesCidade}
                              </td>

                              <td style={{
                                textTransform: 'uppercase'
                              }} onClick={() => handleEditPessoa(pessoa)}>
                                {pessoa.pesEstado}
                              </td>

                              {parseInt(sessionStorage.pesAdmin) === 1 ? (
                              <td width={40} className='tdAlignCenter'>
                                <label onClick={() => handleSelectPosicaoChange(pessoa)}>
                                  {parseInt(pessoa.pesAssociado) === 1 
                                  ? 
                                  <ThumbUpAlt style={{ color: 'green', marginRight: '5px' }} /> 
                                  : 
                                  <ThumbUpAlt style={{ color: 'red', marginRight: '5px' }} />}
                                </label>
                              </td> 
                              ) : <></>}

                              {parseInt(sessionStorage.pesAdmin) === 1 ? (
                              <td width={40} className='tdAlignCenter'>
                                  <label onClick={() => handleSelectStatusChange(pessoa)}>
                                    {parseInt(pessoa.pesStatus) === 1 
                                    ? 
                                    <ThumbUpAlt style={{ color: 'green', marginRight: '5px' }} /> 
                                    : 
                                    <ThumbUpAlt style={{ color: 'red', marginRight: '5px' }} />}
                                  </label>
                              </td> 
                              ) : <></>}

                              {parseInt(sessionStorage.pesAdmin) === 1 ? (
                              <td width={40} className='tdAlignCenter'>
                                <label style={{ cursor: 'pointer', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSelectAdminChange(pessoa)}>
                                    {parseInt(pessoa.pesAdmin) === 1 
                                    ? 
                                    <ThumbUpAlt style={{ color: 'green', marginRight: '5px', cursor: 'pointer' }} /> 
                                    : 
                                    <ThumbUpAlt style={{ color: 'red', marginRight: '5px', cursor: 'pointer' }} />}
                                </label>
                              </td>
                              ) : <></>}

                            </tr>
                          ))}
                      </tbody>
                  </table>
              )
            }
          </div>
        {/* </ContainerPage> */}
      </main>
    </div>
  );
}

export default Associados;